const AppConfig = {
    DEFAULT_CARD_IMAGE: '/images/og-default.png',
    SITE_NAME: 'Josenaldo Matos',
    SITE_DESCRIPTION: 'Software ',
}

export default AppConfig
